export default __webpack_public_path__ + "static/media/Haba-Cuddy-Foxie-1.bbe4b8c6.jpg";